// File cannot be called "Version.ts" as it would conflict with version.ts file

export class Version {
  private static VERSION_SEPARATOR = '.'
  public static INITIAL_VERSION = '1.0'

  static parseVersion(version: number | string): number[] {
    if (typeof version === 'number') {
      return [version, 0]
    }

    return version.split(Version.VERSION_SEPARATOR).map(item => parseInt(item))
  }

  static incrementMajor(version: number | string) {
    const parsedVersion = Version.parseVersion(version)

    parsedVersion[0]++
    parsedVersion[1] = 0

    return parsedVersion.join(Version.VERSION_SEPARATOR)
  }

  static incrementMinor(version: number | string) {
    // BC to make designer 1.7 to work with 1.5 bots - keep version as number until first major update
    if (typeof version === 'number') {
      return String(version)
    }

    if (parseInt(version).toString() === version) {
      return String(parseInt(version) + 1)
    }

    const parsedVersion = Version.parseVersion(version)
    parsedVersion[1]++

    return parsedVersion.join(Version.VERSION_SEPARATOR)
  }

  static increment(type: VersionIncrement, version: string): string {
    return type === 'minor' ? Version.incrementMinor(version) : Version.incrementMajor(version)
  }

  static isFirstGreater(left: string, right: string) {
    const [leftMajor, leftMinor] = Version.parseVersion(left)
    const [rightMajor, rightMinor] = Version.parseVersion(right)

    if (leftMajor > rightMajor) {
      return true
    }

    if (leftMajor === rightMajor) {
      return leftMinor > rightMinor
    }

    return false
  }

  static max(left: string, right: string) {
    return Version.isFirstGreater(left, right) ? left : right
  }
}

export type VersionIncrement = 'minor' | 'major'
